import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90d870f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-item px-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hashtag text-white" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: _ctx.obj,
      class: _normalizeClass([{
            'active': this.$route.params.game === _ctx.obj.params.game &&  this.$route.query.category === _ctx.obj.query.category
        }, "sidebar-link ms-1"])
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["to", "class"])
  ]))
}